import React, { useContext, useEffect, useState } from "react";
import { PngImages, SvgImages } from "../../../Utils/LocalImages";
import Image from "../../../Components/Reusable/Image";
import { ConfirmationModalTheme, ImageFilters } from "../../../Utils/Enums";
import generatePaginationFooter from "../../../Components/Reusable/CustomPagination";
import { handleApiErrors, InputType } from "../../../Utils/Utils";
import ConfirmationModal from "../../../Components/modal/ConfirmationModal";
import { toast } from "react-toastify";
import ButtonWithIcon from "../../../Components/Reusable/ButtonWithIcon";
import DynamicService from "../../../Services/DynamicService";
import { Link, useNavigate } from "react-router-dom";
import RoutesPath from "../../../Utils/RoutesPath";
import * as XLSX from "xlsx";
import CustomDropDown from "../../../Components/Reusable/CustomDropDown";
import DataProvider from "../../../Utils/DataProvider";
import { AuthContext } from "../../../Context/authContext";
// import CustomTextField from "../../Components/Reusable/CustomTextField";
import DistrictService from "../../../Services/DistrictService";
import TalukaService from "../../../Services/TalukaService";
import BharatSatService from "../../../Services/BharatSatService";
import ClassService from "../../../Services/ClassService";
// import { CirclesWithBar } from "react-loader-spinner";
import parse from "html-react-parser";
import { FaCheck } from "react-icons/fa6";
import SubmitButton from "../../../Components/Reusable/Buttons";
import { HiX } from "react-icons/hi";

const BharatSatExamResult = () => {
  const [data, setData] = useState([]);
  const [searchQuery, setSearchQuery] = useState(null);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [availableDataCount, setAvailableDataCount] = useState(0);
  const [deleteId, setDeleteId] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isMultipleDelete, setIsMultipleDelete] = useState(false);
  const [allQuestions, setAllQuestions] = useState([]);
  const { user } = useContext(AuthContext);
  const [filterDistricts, setFilterDistricts] = useState([]);
  const [resetDistrict, setResetDistrict] = useState(false);
  const [resetFilterDistrict, setResetFilterDistrict] = useState(false);
  const [selectedDistrictFilter, setSelectedDistrictFilter] = useState("");
  const [filterTalukas, setFilterTalukas] = useState([]);
  const [resetTaluka, setResetTaluka] = useState(false);
  const [resetFilterTaluka, setResetFilterTaluka] = useState(false);
  const [selectedTalukaFilter, setSelectedTalukaFilter] = useState("");
  const [bharatSatExamNames, setBharatSatExamNames] = useState([]); // State to hold BharatSat exam names
  const [selectedBharatSatExamNameFilter, setSelectedBharatSatExamNameFilter] = useState("");
  const [selectedClassFilter, setSelectedClassFilter] = useState("");
  const [selectedMedium, setSelectedMedium] = useState(null);
  const [mediumList, setMediumList] = useState(DataProvider.mediumList);
  const [classes, setClasses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [selectedRegisterBy, setSelectedRegisterBy] = useState(null);
  const [selectedSubjectId, setSelectedSubjectId] = useState(null);
  const [dataTwo, setDataTwo] = useState([]);
  const [currentSubjectIndex, setCurrentSubjectIndex] = useState(0);
  const [activeTab, setActiveTab] = useState('');
  const [cumulativeCount, setCumulativeCount] = useState(1);
  const [subjectStartingIndexes, setSubjectStartingIndexes] = useState({});
  const [lastQuestionIndex, setLastQuestionIndex] = useState({});
  const [loading, setLoading] = useState(false);
  const [openIndex, setOpenIndex] = useState(null);
  const [bharatSatSubmissions, setbharatSatSubmissions] = useState("")
  const [showDropdown, setShowDropdown] = useState(false);
  const [buttonIcon, setButtonIcon] = useState(SvgImages.magicalstar)
  const [selectedRank, setSelectedRank] = useState('');
  const [selectedId, setSelectedId] = useState('')

  const navigate = useNavigate();
  const fetchData = async () => {
    try {
      const response = await BharatSatService.getBharatSatExamResult(
        offset,
        limit,
        searchQuery || "",
        selectedClassFilter?.value || "",
        selectedMedium || "",
        selectedDistrictFilter.name || "",
        selectedTalukaFilter.name || "",
        selectedBharatSatExamNameFilter || "",
      );
      setData(response.data);

      setAvailableDataCount(response.availableDataCount);
      if (offset != 0 && offset * limit > availableDataCount - 1) {
        setOffset(offset - 1);
      }
    } catch (error) {
      handleApiErrors(error);
    }
  };
  useEffect(() => {
    const uniqueExamNames = [...new Set(data.map(item => item.bharatSatExamName))];
    setBharatSatExamNames(uniqueExamNames.map(name => ({ value: name, label: name }))); // Format for dropdown
  }, [data]);
  const deleteSingleUser = async (id) => {
    try {
      await BharatSatService.deletebharatsatresult([id]);
      toast.success("User Deleted successfully");
      setShowDeleteModal(false);
      setOffset(0);
      fetchData();
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  const deleteMultipleuser = async () => {
    try {
      if (data?.findIndex((item) => item.isChecked) != -1) {
        var itemsToDelete = [];
        data.map((item) => {
          if (item.isChecked) {
            itemsToDelete.push(item.bharatSatSubmissions_id);
          }
        });
      }
      await BharatSatService.deletebharatsatresult(itemsToDelete);
      toast.success("Users Deleted successfully");
      setShowDeleteModal(false);
      setOffset(0);
      fetchData();
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  useEffect(() => {
    fetchData();
    getAllFilterDistricts();
    getAllClasses()
  }, [offset, selectedClassFilter]);

  useEffect(() => {
    const timeOutId = setTimeout(() => {
      setOffset(0);
      if (
        searchQuery != null ||
        selectedClassFilter != null ||
        selectedMedium != null ||
        selectedDistrictFilter != null ||
        selectedTalukaFilter != null ||
        selectedBharatSatExamNameFilter != null
      ) {
        fetchData();
      }
    }, 500);
    return () => clearTimeout(timeOutId);
  }, [searchQuery, selectedClassFilter, selectedMedium, selectedDistrictFilter, selectedBharatSatExamNameFilter,]);


  const exportToExcel = (data, fileName) => {
    if (!data || data.length === 0) {
      toast.info("No data to export");
      return;
    }

    // Create a worksheet from data
    const ws = XLSX.utils.json_to_sheet(data);

    // Define the grand total row
    // const grandTotalRow = [
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "Grand Total",
    // ];

    // Add grand total row to the end of the sheet
    // XLSX.utils.sheet_add_aoa(ws, [grandTotalRow], { origin: -1 });

    // Create a new workbook and append the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // Write the workbook to file
    XLSX.writeFile(wb, fileName);
  };

  const handleExportClick = () => {
    const name = user.name || "";
    const fileName = `${name} Student Report.xlsx`;
    exportToExcel(data, fileName);
  };

  const getAllFilterDistricts = async (state_id = null) => {
    try {
      const response = await DistrictService.getAll(state_id);
      setFilterDistricts(response.data);
    } catch (error) {
      handleApiErrors(error);
    }
  };
  const getAllFilterTalukas = async (district_id) => {
    try {
      const response = await TalukaService.getAll(district_id);
      setFilterTalukas(district_id ? response.data : []);
    } catch (error) {
      handleApiErrors(error);
    }
  };

  useEffect(() => {
    // Reset taluka when district changes
    if (resetFilterDistrict) {
      setSelectedTalukaFilter("");
      setResetFilterDistrict(false);
    }
  }, [resetFilterDistrict]);

  const selectedSubjectSummary = subjects.find(
    (subject) => subject.subjectId === selectedSubjectId
  );
  const getAllClasses = async () => {
    try {
      const response = await ClassService.getAllClassesWithoutPagination();
      setClasses(response.data);
    } catch (error) {
      handleApiErrors(error);
    }
  };


  const fetchResult = async (bharatSatSubmissions_id, subject_id = null) => {
    setLoading(true);
    setbharatSatSubmissions(bharatSatSubmissions_id)
    try {
      const response = await BharatSatService.getBharatSatViewExamList(bharatSatSubmissions_id, subject_id);
      const { subjects, questions, ...rest } = response.data;

      if (subject_id === null && subjects.length > 0) {
        // Set default subject
        const defaultSubject = subjects[0];
        setSelectedSubjectId(defaultSubject.subjectId);
        setActiveTab(defaultSubject.subjectName);

        // Call fetchResult with the default subject ID after the state is updated
        return fetchResult(bharatSatSubmissions_id, defaultSubject.subjectId);
      }

      if (Array.isArray(questions) && questions.length > 0) {
        // Handle question counting and starting index logic
        if (subject_id && !subjectStartingIndexes[subject_id]) {
          setSubjectStartingIndexes(prev => ({
            ...prev,
            [subject_id]: cumulativeCount,
          }));
        }

        let questionCount = 0;
        for (const question of questions) {
          if (question.typeOfQuestion === "Comprehensive" || question.typeOfQuestion === "Poem") {
            questionCount += question?.subQuestions?.length || 0;
          } else {
            questionCount++;
          }
        }

        setLastQuestionIndex(prev => ({
          ...prev,
          [subject_id]: cumulativeCount + questionCount - 1,
        }));
        setCumulativeCount(prevCount => prevCount + questionCount);
      } else {
        console.error('Questions are invalid or empty');
      }

      setSubjects(subjects);
      setAllQuestions(questions);
      setDataTwo(rest);
      if (rest?.rank) {
        setSelectedRank({ value: rest.rank, label: rest.rank }); // This will set the selected rank in dropdown
      }
      console.log(dataTwo?.rank, "hjkgh");


    } catch (error) {
      handleApiErrors(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (subjects.length > 0 && selectedSubjectId === null) {
      const firstSubject = subjects[0];
      setSelectedSubjectId(firstSubject.subjectId);
      setActiveTab(firstSubject.subjectName);
    }
  }, [subjects, selectedSubjectId, dataTwo]);
  const handleSubjectChange = (direction, subjectId = null, subjectName = null) => {
    console.log(subjectId, direction, subjectName, "subject", "dgs",);

    scrollToTop();
    let newIndex = currentSubjectIndex;
    let newCumulativeCount = cumulativeCount;

    // Logic for "next" button click
    if (direction === 'next' && currentSubjectIndex < subjects.length - 1) {
      newIndex = currentSubjectIndex + 1;
    }
    // Logic for "previous" button click
    else if (direction === 'previous' && currentSubjectIndex > 0) {
      newIndex = currentSubjectIndex - 1;
    }
    // Handle tab click navigation
    else if (subjectId !== null && subjectName !== null) {
      // Find the index of the clicked subject based on subjectId
      const clickedSubjectIndex = subjects.findIndex(subject => subject.subjectId === subjectId);
      if (clickedSubjectIndex !== -1) {
        newIndex = clickedSubjectIndex;
      }
    }

    const currentSubject = subjects[newIndex];
    const currentSubjectId = currentSubject?.subjectId;

    // Ensure that we are using the correct cumulative index for this subject
    if (currentSubjectId && subjectStartingIndexes[currentSubjectId] !== undefined) {
      newCumulativeCount = subjectStartingIndexes[currentSubjectId]; // Start from the stored index for this subject
    }

    // Update the state and UI
    setCurrentSubjectIndex(newIndex); // Update current subject index
    setSelectedSubjectId(currentSubject?.subjectId); // Update selected subject ID
    setActiveTab(currentSubject?.subjectName); // Update active tab

    // Update cumulative count
    setCumulativeCount(newCumulativeCount); // Update cumulative count for continuous indexing

    console.log({
      direction,
      newIndex,
      currentSubjectId,
      activeTab: currentSubject?.subjectName,
      newCumulativeCount,
    });

    fetchResult(bharatSatSubmissions, currentSubject?.subjectId);

    // Fetch the subject data again with updated cumulative count
  };
  const scrollToTop = () => {
    document.getElementById("scroll_bar1").scroll(0, 0)
  }



  const cleanQuestionText = (text) => {
    return text.replace(/&nbsp;/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  };

  const customParser = (node) => {
    if (node.name === "oembed") {
      const url = node.attribs.url;
      let videoId;
      // Handle both normal YouTube URLs (youtube.com) and short URLs (youtu.be)
      if (url.includes("youtube.com")) {
        videoId = new URL(url).searchParams.get("v");  // Extract the video ID from the "v" parameter
      } else if (url.includes("youtu.be")) {
        videoId = url.split("/").pop().split("?")[0];  // Extract the ID after the last "/"
      }
      if (videoId) {
        return (
          <iframe
            width="560"
            height="315"
            src={`https://www.youtube.com/embed/${videoId}`}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="YouTube video"
          />
        );
      } else {
        return <p className='text-danger'>Invalid YouTube URL</p>;
      }
    }
  };
  const getAlphabetLabel = (index) => {
    const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    return letters[index] || "";
  };

  const handleToggleSolution = (index) => {
    // Toggle solution visibility
    setOpenIndex(openIndex === index ? null : index);
  };

  const handleDropdownChange = (selectedOption) => {

    setSelectedRank(selectedOption);
  };

  const addStudentRank = async (selectedRank) => {
    try {
      const response = await BharatSatService.addstudentrank(
        selectedRank.value,
        dataTwo?.bharatSatSubmissions_id
        // Pass both ID and rank
      );
      fetchResult(dataTwo?.bharatSatSubmissions_id)
      toast.success(response.message);
      setButtonIcon(SvgImages.magicalstar); // Change icon on success
    } catch (error) {
      handleApiErrors(error);
      toast.error("Failed to rank. Please try again later.");
    }
  };


  const handleButtonClick = () => {

    const rankPrivileages = user?.setPrivileges?.find(
      (priv) => priv.parameter === "Bharat Sat Exam"
    );


    if (!rankPrivileages?.update) {
      toast.warning("You don't have permission to add rank.");
      return; // Exit early if the user doesn't have permission
    }

    if (showDropdown) {
      if (selectedRank) {
        addStudentRank(selectedRank);  // Trigger API call if rank is selected
      } else {
        setShowDropdown(true)
        toast.warning("Please select a rank before proceeding.");
      }
    }
    // Toggle the dropdown visibility
    setShowDropdown(!showDropdown);
    setButtonIcon(!showDropdown ? SvgImages.tick_mark : SvgImages.magicalstar);
  };


  const handleClassChange = (e) => {
    const selectedOption = e ? { value: e.value, label: e.label } : { value: "", label: "Class" };
    // Set only the class ID (value)
    setSelectedClassFilter({ value: selectedOption.value, label: selectedOption.label });
    setOffset(0); // Reset offset
  };

  const handleMediumChange = (selectedOption) => {
    setSelectedMedium(selectedOption?.value || ""); // Reset to "" if "All" is selected
    setOffset(0);
  };

  // Ensure selectedOption is derived correctly:
  const selectedmedium =
    [{ value: "", label: "All" }, ...mediumList ?? []].find(
      (option) => option.value === selectedMedium
    ) || null;


  const handleDistrictChange = (e) => {
    const selected = filterDistricts.find(d => d._id === e.value);
    setSelectedDistrictFilter({
      id: selected?._id || "",
      name: selected?.name || "",
    });
    setResetFilterTaluka(true);
    getAllFilterTalukas(selected?._id || selected?.name); // Pass ID here
    setSelectedTalukaFilter("");
    setOffset(0);
  };



  return (
    <div>
      <div className="mb-3 d-flex justify-content-between align-items-center">
        <h1 className="black fs-18 fw-600 mb-0 text-uppercase">
          {" "}
          Bharat SAT Result
        </h1>
        <div className="d-flex align-items-center gap-1">
          <a className="back_login m-0 cursor-pointer" onClick={() => window.location.reload()}>
            <Image src={SvgImages.back_arrow_login} className="m-0" />
            Back
          </a>
          <h4 className="fs-12 fw-500 black mb-0 mx-1">Dashboard &gt;</h4>
          <h4 className="fs-12 fw-500 primary mb-0">
            {" "}
            Bharat SAT
          </h4>
        </div>
      </div>
      {dataTwo?.bharatSatSubmissions_id ? (
        <div className="table_container" id="scroll_bar1" >
          <div className="d-flex justify-content-between mb-4 align-items-center">
            <h1 className="black fs-18 fw-600 ">Student Details</h1>
            <div className="d-flex align-items-center gap-4 respoexportbtn">
              <div className="">
                <ButtonWithIcon
                  text={"Add to toppers list"}
                  icon={buttonIcon}
                  onClick={handleButtonClick}
                />
              </div>
              {showDropdown && (
                <div>
                  <CustomDropDown
                    placeholder="Rank"
                    inputType={InputType.text}
                    labelClass="commissionsection"
                    Dropdownclass="marginsection"
                    options={DataProvider.Rank}
                    value={selectedRank || ''}
                    onChange={handleDropdownChange}
                  />
                </div>
              )}

            </div>

          </div>

          {/* <div className=" ">Personal Details</div> */}
          <div className="rounded shadow ">
            {" "}
            <div style={{ overflowX: "auto" }}>
              <table
                className="table mb-0  table-bordered"
                id="dtHorizontalExample"
                cellSpacing="0"
                width="100%"
              >
                <thead className="border">
                  <tr>
                    <td className="fs-16 fw-600  blue">Student Details</td>
                  </tr>
                  <tr>
                    <th style={{ width: "20%" }}> Name</th>
                    <td className="text-capitalize" style={{ width: "20%" }}>{dataTwo?.firstName + " " + dataTwo?.lastName}</td>
                    <th style={{ width: "20%" }}>Class</th>
                    <td className="text-capitalize" style={{ width: "20%" }}>{dataTwo?.class_name}</td>
                  </tr>
                  <tr>
                    <th style={{ width: "20%" }}>Medium</th>
                    <td className="text-capitalize" style={{ width: "20%" }}>{dataTwo?.medium}</td>
                    <th style={{ width: "20%" }}>District</th>
                    <td style={{ width: "20%" }}>
                      {dataTwo?.district}
                    </td>
                  </tr>{" "}
                  <tr>
                    <th style={{ width: "20%" }}>Taluka</th>
                    <td style={{ width: "20%" }}>{dataTwo?.taluka}</td>
                  </tr>{" "}
                </thead>
              </table>
            </div>
          </div>
          <div className="Performancesection mt-4">
            <div>
              <h3 className="fs-16 fw-600  blue mb-0">My Overall Performance Summary</h3>
            </div>

            <div className="d-flex row  mt-3">
              <div className="d-flex mb-2 col-md-3 col-sm-3 col-6 gap-2 align-items-center">
                <div className="view-result-icon green_two">
                  <Image src={PngImages.fileplus} />
                </div>
                <div>
                  <h3 className=" fs-18 fw-600 mb-0">{Math.max(dataTwo.score, 0)}/{dataTwo.totalMarks}</h3>
                  <span className="fs-12 captioncolor fw-500">Marks</span>
                </div>
              </div>
              <div className="d-flex mb-2 col-md-3 col-sm-3 col-6 gap-2 align-items-center ">
                <div className="view-result-icon golden">
                  <Image src={PngImages.attempted} />
                </div>
                <div>
                  <h3 className=" fs-18 fw-600 mb-0">{dataTwo.totalAttemptQuestions}/{dataTwo.totalQuestions}</h3>
                  <span className="fs-12 captioncolor fw-500">Attempted</span>
                </div>
              </div>

              <div className="d-flex mb-2 col-md-3 col-sm-3 col-6 gap-2 align-items-center">
                <div className="view-result-icon pink">
                  <Image src={PngImages.correct} />
                </div>
                <div>
                  <h3 className=" fs-18 fw-600 mb-0">{dataTwo.totalCorrectQuestions}/{dataTwo.totalQuestions}</h3>
                  <span className="fs-12 captioncolor fw-500">Correct</span>
                </div>
              </div>

              <div className="d-flex mb-2 col-md-3 col-sm-3 col-6 gap-2 align-items-center">
                <div className="view-result-icon orangebg">
                  <Image src={PngImages.incorrect} />
                </div>
                <div>
                  <h3 className=" fs-18 fw-600 mb-0">{dataTwo.totalIncorrectQuestions}/{dataTwo.totalQuestions}</h3>
                  <span className="fs-12 captioncolor fw-500">Incorrect</span>
                </div>
              </div>
            </div>
            <div>
              <h3 className="fs-16 fw-600  blue mb-0 mt-4">Total Time Taken</h3>
            </div>
            <div className="d-flex row mt-1">
              <div className="d-flex  mb-0 col-md-3  col-sm-3 col-6  gap-2 align-items-center">
                <div className="view-result-icon darkblue">
                  <Image src={PngImages.timeicon} />
                </div>

                <div>
                  <span className="fs-12 captioncolor fw-500 text-truncate">hh : mm : ss</span>
                  <h3 className=" fs-18 fw-600 mb-0 text-capitalize text-truncate">{dataTwo.startTime}</h3>
                  <span className="fs-12 captioncolor fw-500">Start Time</span>
                </div>
              </div>
              <div className="d-flex  mb-0 col-md-3 col-sm-3 col-6  gap-2 align-items-center">
                <div className="view-result-icon darkpurple">
                  <Image src={PngImages.timeicon} />
                </div>
                <div>
                  <span className="fs-12 captioncolor fw-500 text-truncate">hh : mm : ss</span>
                  <h3 className=" fs-18 fw-600 mb-0 text-capitalize text-truncate">{dataTwo.endTime}</h3>
                  <span className="fs-12 captioncolor fw-500">End Time</span>
                </div>
              </div>
              <div className="d-flex  mb-0 col-md-3 col-sm-3 col-6  gap-2 align-items-center">
                <div className="view-result-icon magenta">
                  <Image src={PngImages.time_taken} />
                </div>
                <div>
                  <span className="fs-12 captioncolor fw-500 text-truncate">hh : mm : ss</span>
                  <h3 className=" fs-18 fw-600 mb-0 text-truncate">{dataTwo.submittedTime}</h3>
                  <span className="fs-12 captioncolor fw-500">Time Taken</span>
                </div>
              </div>
            </div>
          </div>
          <div className="black fs-18 fw-600  my-4">Question Paper</div>

          <ul className="fs-16 overflow-auto fw-600 list-group list-group-horizontal gap-1 mb-3 mt-4 text-white">
            {subjects.map(subject => (
              <li
                key={subject.subjectId}
                className={`list-group-item border-0 ${activeTab === subject.subjectName ? 'active' : ''}`}
                onClick={() => handleSubjectChange(null, subject.subjectId, subject.subjectName)}
                style={{ cursor: 'pointer', borderRadius: "6px", backgroundColor: activeTab === subject.subjectName ? '#14489F' : 'transparent' }}
              >
                {subject.subjectName}
              </li>
            ))}
          </ul>

          <div className="Performancesection">
            <div>
              <h3 className="fs-16 fw-600  blue mb-0">Subject Performance Summary</h3>
            </div>

            <div className="d-flex row mt-3">
              <div className="d-flex mb-0 col-md-3 col-sm-3 col-6 gap-2 align-items-center">
                <div className="view-result-icon green_two">
                  <Image src={PngImages.fileplus} />
                </div>
                <div>
                  <h3 className=" fs-18 fw-600 mb-0">{Math.max(selectedSubjectSummary?.score, 0)}/{selectedSubjectSummary?.totalQuestions * 2}</h3>
                  <span className="fs-12 captioncolor fw-500">Marks</span>
                </div>
              </div>

              <div className="d-flex mb-0 col-md-3 col-sm-3 col-6 gap-2 align-items-center ">
                <div className="view-result-icon golden">
                  <Image src={PngImages.attempted} />
                </div>
                <div>
                  <h3 className=" fs-18 fw-600 mb-0">{selectedSubjectSummary?.attemptedQuestions}/{selectedSubjectSummary?.totalQuestions}</h3>
                  <span className="fs-12 captioncolor fw-500">Attempted</span>
                </div>
              </div>

              <div className="d-flex mb-0 col-md-3 col-sm-3 col-6 gap-2 align-items-center">
                <div className="view-result-icon pink">
                  <Image src={PngImages.correct} />
                </div>
                <div>
                  <h3 className=" fs-18 fw-600 mb-0">{selectedSubjectSummary?.correctQuestions}/{selectedSubjectSummary?.totalQuestions}</h3>
                  <span className="fs-12 captioncolor fw-500">Correct</span>
                </div>
              </div>

              <div className="d-flex mb-0 col-md-3 col-sm-3 col-6 gap-2 align-items-center">
                <div className="view-result-icon orangebg">
                  <Image src={PngImages.incorrect} />
                </div>
                <div>
                  <h3 className=" fs-18 fw-600 mb-0">{selectedSubjectSummary?.incorrectQuestions}/{selectedSubjectSummary?.totalQuestions}</h3>
                  <span className="fs-12 captioncolor fw-500">Incorrect</span>
                </div>
              </div>
            </div>


          </div>

          <section className='fs-16 fw-600 my-4'>

            {loading ? (
              <div className="text-center d-flex justify-content-center">
                {/* <CirclesWithBar
                  height="80"
                  width="80"
                  color="#14489f"
                  ariaLabel="bars-loading"
                  wrapperStyle={{}}
                  wrapperClass=""
                /> */}
              </div>
            ) : (
              <>
                {
                  allQuestions.map((q, index) => {
                    var continuousIndex = subjectStartingIndexes[selectedSubjectId];
                    for (var i = 0; i < index; i++) {
                      continuousIndex += (allQuestions[i]?.subQuestions?.length || 1);
                    }
                    return (
                      <div key={index} className='my-4 border-question pb-4'>
                        <div className="fs-16 fw-600 mb-3">
                          {q.heading} <span style={{ color: q.markColor }}>{q.marks}</span>
                        </div>

                        <div className="fs-16 fw-600 mb-3 d-flex justify-content-start text-center gap-1">
                          {/* Question {index + 1} */}
                          Question {q.typeOfQuestion == "Comprehensive" || q.typeOfQuestion == "Poem" ? "" : continuousIndex}
                          <div>
                            {
                              q.typeOfQuestion === 'General' && (
                                q.selectedOption === null ? (
                                  null  // Show "Not Answered" if no option is selected
                                ) : (
                                  q.correctOption === q.selectedOption ? (
                                    <span style={{ color: "#008000" }}>(+2 marks)</span>  // Show marks only if an option is selected
                                  ) : (
                                    q.negativeMarking === "Yes" ?
                                      <span style={{ color: "#FF0000" }}>(0.5 marks)</span> : null // Incorrect answe
                                  )
                                )
                              )
                            }
                          </div>
                        </div>

                        {q.typeOfQuestion === 'Comprehensive' || q.typeOfQuestion === 'Poem' ? (
                          <div>
                            <div className='fs-14 fw-600 mb-2 pt-2 black border-question-top'>Read Carefully</div>
                            {q?.typeOfQuestion === 'Comprehensive' || q?.typeOfQuestion === 'Poem' ? (

                              <div className=" blog-data-html" style={{ contain: "content", width: '90%' }}>
                                {cleanQuestionText(q.question) && parse(cleanQuestionText(q.question), { replace: customParser })}

                              </div>

                            ) : (
                              null

                            )}

                            {q.subQuestions.map((subQ, subIndex) => {
                              if (subIndex != 0) {
                                continuousIndex++;
                              }
                              const subQuestionNumber = `${continuousIndex}.${subIndex + 1}`; // e.g., 1.1, 1.2
                              return (
                                <div key={subIndex} className='my-4'>
                                  {/* <div className=" d-flex justify-content-between">
                                        <div className="small-medium-text fw-600 text-dark d-flex gap-2">
                                            <span>{subIndex + 1}.</span>{decodeHtml(subQ.question.replace(/&nbsp;/g, ' '))}
                                            <div>
                                                {subQ.selectedOption === null ? (
                                                    null
                                                ) : (
                                                    subQ.correctOption === subQ.selectedOption ? (
                                                        <span style={{ color: "#008000" }}>(+2 marks)</span>  // Correct answer
                                                    ) : (
                                                        <span style={{ color: "#FF0000" }}>(0.5 marks)</span>  // Incorrect answer
                                                    )
                                                )}
                                            </div>
                                        </div>
                                        <div>
                                            {subQ.selectedOption == null ? (
                                                <span style={{ color: "#FF0000" }}>Not Answered</span>
                                            ) : (
                                                null
                                            )}
                                        </div>
                                    </div> */}
                                  <div className=" d-flex justify-content-between">
                                    <div className="d-flex gap-2 align-items-center">
                                      <div className="fs-16 fw-600 text-dark d-flex  align-items-center gap-2">

                                        <div style={{ marginBottom: '9px' }}>{continuousIndex}.</div>
                                        {q?.typeOfQuestion === 'Poem' || 'Comprehensive' ? (

                                          <div className="w-100 blog-data-html mt-2" style={{ contain: "content" }}>
                                            {cleanQuestionText(subQ?.question) && parse(cleanQuestionText(subQ.question), { replace: customParser })}
                                          </div>

                                        ) : (
                                          null

                                        )}

                                      </div>

                                      <div style={{ marginBottom: '9px' }}>
                                        {subQ.selectedOption === null ? (
                                          null
                                        ) : (
                                          subQ.correctOption === subQ.selectedOption ? (
                                            <span style={{ color: "#008000" }}>(+2 marks)</span>  // Correct answer
                                          ) : (
                                            q.negativeMarking === "Yes" ?
                                              <span style={{ color: "#FF0000" }}>(0.5 marks)</span> : null // Incorrect answe 
                                          )
                                        )}
                                      </div>
                                    </div>
                                    <div>
                                      {subQ.selectedOption == null ? (
                                        <span style={{ color: "#FF0000" }}>Not Answered</span>
                                      ) : (
                                        null
                                      )}
                                    </div>
                                  </div>
                                  <ol className="list-group mt-4">
                                    {subQ.options.map((option, optIndex) => {
                                      const isUserSelected = subQ.selectedOption === optIndex;
                                      const isCorrectOption = subQ.correctOption === optIndex;

                                      return (
                                        <li
                                          key={optIndex}
                                          className="list-group-item d-flex gap-2 justify-content-between align-items-start border-0 py-0"
                                          style={{
                                            color: isCorrectOption ? 'green' : (isUserSelected && !isCorrectOption) ? 'red' : 'inherit',
                                          }}
                                        >
                                          <div className="ms-2 me-auto form-check d-flex align-items-center p-0">
                                            <div className="checkmarks"
                                              style={{
                                                border: isCorrectOption ? 'none' : (isUserSelected && !isCorrectOption ? 'red' : '1px solid #ccc'),
                                                backgroundColor: isCorrectOption ? 'green' : (isUserSelected && !isCorrectOption ? 'red' : 'white'),
                                                marginBottom: "16px"
                                              }}
                                            >
                                              {isUserSelected && !isCorrectOption ? <HiX style={{ fontSize: '16px' }} /> : (isCorrectOption ? <FaCheck style={{ fontSize: '15px' }} /> : '')}                                                                  </div>
                                            <label
                                              className="form-check-label fs-16 fw-500 px-2  "
                                              htmlFor={`Comprehensive-option-${index}-${subIndex}`}
                                            >
                                              <div className="d-flex gap-2">
                                                <span style={{ marginTop: '1px' }}>{getAlphabetLabel(optIndex)}. </span> <span>{cleanQuestionText(option) && parse(cleanQuestionText(option), { replace: customParser })}</span>
                                                <div className="text-end" style={{ marginTop: '2px' }}>
                                                  {isCorrectOption && !isUserSelected && (
                                                    <span className="small-text ms-3 fw-600" style={{ fontStyle: 'italic' }}>Correct Answer</span>
                                                  )}
                                                  {isUserSelected && !isCorrectOption && (
                                                    <span className="text-danger small-text ms-3 fw-600" style={{ fontStyle: 'italic' }}>Incorrect Answer</span>
                                                  )}
                                                  {isUserSelected && isCorrectOption && (
                                                    <span className="small-text ms-3 fw-600" style={{ fontStyle: 'italic' }}>Your Answer</span>
                                                  )}
                                                </div>
                                              </div>

                                            </label>
                                          </div>
                                        </li>
                                      );
                                    })}
                                  </ol>
                                  {subQ.solution !== "" ? (
                                    <div className="d-flex gap-2 align-items-center mt-2">
                                      <div className='d-flex gap-1 align-items-center'>
                                        <Image src={PngImages.light_bulb} alt="Light Bulb Icon" />
                                        <div>
                                          <h3 className="fs-16 fw-600 mb-0">Solution</h3>
                                        </div>
                                      </div>
                                      <div
                                        className="borderBottom dotted blue"
                                        style={{ fontStyle: "italic", cursor: 'pointer', borderBottom: '1px dotted #14489f' }}
                                        onClick={() => handleToggleSolution(`${index}-${subIndex}`)}
                                      >
                                        <h3 className="fs-16 fw-600 blue mb-0">
                                          {openIndex === `${index}-${subIndex}` ? 'Hide' : 'Show'}
                                        </h3>
                                      </div>
                                    </div>) : null}
                                  {openIndex === `${index}-${subIndex}` && (
                                    <div className="mt-3" style={{ lineHeight: '24px' }}>
                                      <div className="fs-16 fw-600">
                                        {subQ?.typeOfQuestion === 'Poem' || 'Comprehensive' ? (

                                          <div className="w-100 blog-data-html mt-2" style={{ contain: "content" }}>
                                            {cleanQuestionText(subQ.solution) && parse(cleanQuestionText(subQ.solution), { replace: customParser })}
                                          </div>

                                        ) : (
                                          null
                                        )}
                                      </div>

                                    </div>
                                  )}
                                </div>
                              )
                            })}
                          </div>
                        ) : (
                          <div>
                            <div className="d-flex justify-content-between">
                              {q?.typeOfQuestion === 'General' ? (

                                <div className=" blog-data-html " style={{ contain: "content", width: '90%' }}>

                                  {cleanQuestionText(q.question) && parse(cleanQuestionText(q.question), { replace: customParser })}

                                </div>

                              ) : (
                                null
                              )}

                              <div>
                                {q.selectedOption == null ? (
                                  <span style={{ color: "#FF0000" }}>Not Answered</span>
                                ) : (
                                  null
                                )}
                              </div>
                            </div>

                            <ol className="list-group my-4">
                              {q.options.map((option, optIndex) => {
                                const isUserSelected = q.selectedOption === optIndex;
                                const isCorrectOption = q.correctOption === optIndex;

                                return (
                                  <li
                                    key={optIndex}
                                    className="list-group-item d-flex gap-2 justify-content-between align-items-start border-0 py-0"
                                    style={{
                                      color: isCorrectOption ? 'green' : (isUserSelected && !isCorrectOption) ? 'red' : 'inherit',
                                    }}
                                  >
                                    <div className="ms-2 me-auto form-check d-flex align-items-center p-0">
                                      <div className="checkmarks"
                                        style={{
                                          border: isCorrectOption ? 'none' : (isUserSelected && !isCorrectOption ? 'red' : '1px solid #ccc'),
                                          backgroundColor: isCorrectOption ? 'green' : (isUserSelected && !isCorrectOption ? 'red' : 'white'),
                                          marginBottom: "16px"
                                        }}
                                      >
                                        {isUserSelected && !isCorrectOption ? <HiX style={{ fontSize: '16px' }} /> : (isCorrectOption ? <FaCheck style={{ fontSize: '15px' }} /> : '')}                                                                  </div>
                                      <label
                                        className="form-check-label fs-16 fw-500 px-2"
                                        htmlFor={`General-option-${index}-${optIndex}`}
                                      >
                                        <div className="d-flex gap-2">
                                          <span style={{ marginTop: '1px' }}>{getAlphabetLabel(optIndex)}. </span> <span><p>{cleanQuestionText(option) && parse(cleanQuestionText(option), { replace: customParser })}</p></span>
                                          <div style={{ marginTop: '2px' }}>
                                            {isCorrectOption && !isUserSelected && (
                                              <span className="small-text ms-3 fw-600" style={{ fontStyle: 'italic' }}>Correct Answer</span>
                                            )}
                                            {isUserSelected && !isCorrectOption && (
                                              <span className="text-danger small-text ms-3 fw-600" style={{ fontStyle: 'italic' }}>Incorrect Answer</span>
                                            )}
                                            {isUserSelected && isCorrectOption && (
                                              <span className="small-text ms-3 fw-600" style={{ fontStyle: 'italic' }}>Your Answer</span>
                                            )}
                                          </div>
                                        </div>
                                      </label>
                                    </div>
                                  </li>
                                );
                              })}
                            </ol>{
                              q.solution !== "" ? (
                                <div className="d-flex gap-2 align-items-center mt-2">
                                  <div className='d-flex gap-1 align-items-center'>
                                    <Image src={PngImages.light_bulb} alt="Light Bulb Icon" />
                                    <div>
                                      <h3 className="fs-16 fw-600 mb-0">Solution</h3>
                                    </div>
                                  </div>
                                  <div
                                    className="borderBottom dotted blue"
                                    style={{ fontStyle: "italic", cursor: 'pointer', borderBottom: '1px dotted #14489f' }}
                                    onClick={() => handleToggleSolution(index)}
                                  >
                                    <h3 className="fs-16 fw-600 blue mb-0">
                                      {openIndex === index ? 'Hide' : 'Show'}
                                    </h3>
                                  </div>
                                </div>
                              ) : null}
                            {openIndex === index && (
                              // <div className="mt-3" style={{ lineHeight: '24px' }}>
                              //     <div className="small-medium-text fw-600">{decodeHtml(q.solution?.replace(/&nbsp;/g, ' '))}</div>
                              // </div>
                              <div className="mt-3" style={{ lineHeight: '24px' }}>
                                <div className="fs-16 fw-600">
                                  {q?.typeOfQuestion === 'General' ? (

                                    <div className="w-100 blog-data-html mt-2" style={{ contain: "content" }}>
                                      {cleanQuestionText(q.solution) && parse(cleanQuestionText(q.solution), { replace: customParser })}
                                    </div>

                                  ) : (
                                    null
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    )
                  })}</>)}
          </section>

          <div className="d-flex flex-wrap justify-content-between align-items-center fs-16 fw-400 px-2 gap-2">
            <div className="d-flex gap-3">
              <SubmitButton
                title={'Previous'}
                className="previewbtn"
                onClick={() => handleSubjectChange('previous')} // Previous button
                disabled={currentSubjectIndex === 0} // Disable if first subject
              />
            </div>

            <div className="d-flex gap-3">
              <SubmitButton
                className="nextbtn"
                title={'Next'}
                onClick={() => handleSubjectChange('next')} // Next button
                disabled={currentSubjectIndex === subjects.length - 1} // Disable if last subject
              />
            </div>
          </div>

          <div className="d-flex justify-content-start">
            <div
              className="blue cursor-pointer mt-3 fw-500 fs-14"
              onClick={() => {
                setDataTwo(null); // Clear the details view
                // setSearchDistrict(""); // Reset District filter to an empty string
                // setSearchTaluka(""); // Reset Taluka filter to an empty string
                // setSearchQuery(""); // Reset Search Query if necessary
                // setOffset(0); // Reset offset to start from the beginning
                // Fetch all data again without filters
              }}
            >
              {" "}
              <Image src={SvgImages.left_arrow} className="blue mx-3" />
              Back
            </div>
          </div>
        </div>
      ) : (
        <div className="table_container" style={{ display: "block" }}>
          {/* <h1 className="black fs-18 fw-600 mb-0">Registration Page Listing</h1> */}

          <div className="table_title">
            <div className="table_headings ">
              <h1 className="black fs-18 fw-600 mb-0">
                <div
                  className="table_delete_icon"
                  style={{
                    opacity:
                      data?.findIndex((item) => item.isChecked) == -1 ? 0.3 : 1,
                    pointerEvents:
                      data?.findIndex((item) => item.isChecked) === -1
                        ? "none"
                        : "auto",
                  }}
                  onClick={() => {
                    const bharatsatExamPrivilege = user?.setPrivileges?.find(
                      (priv) => priv.parameter === "Bharat Sat Exam"
                    );
                    if (!bharatsatExamPrivilege?.delete) {

                      toast.warning(
                        "You don't have permission to delete results."
                      );
                      return;
                    }

                    if (!(data.findIndex((item) => item.isChecked) == -1)) {
                      setIsMultipleDelete(true);
                      setShowDeleteModal(true);
                    }
                  }}
                >
                  <Image src={SvgImages.deleteIcon} alt="Delete Icon" />
                </div>
              </h1>
              <div className="d-flex gap-4 align-items-center ">
                <div className="position-relative ">
                  <input
                    type="search"
                    className="search_box search_bar"
                    placeholder="Search exam"
                    onChange={(e) => {
                      setSearchQuery(e.target.value);
                    }}
                  />
                  <Image
                    src={SvgImages.search}
                    style={ImageFilters.gray}
                    className="search_icon"
                    alt="Search Icon"
                    height="20px"
                  />
                </div>
                <div className="search_box search_bar w-100 ">
                  <CustomDropDown
                    placeholder="Select BharatSat Exam Name"
                    inputType={InputType.text}
                    resetValue={resetFilterTaluka}
                    Dropdownclass="marginsection"
                    labelClass="commissionsection"
                    setResetValue={setResetFilterTaluka}
                    onChange={(e) => {
                      setSelectedBharatSatExamNameFilter(e.value); // Update the selected exam name filter

                    }}
                    options={[
                      { value: "", label: "Bharat SAT Exam Name" }, // Option for "All"
                      ...bharatSatExamNames, // Use the extracted exam names
                    ]}
                    value={
                      selectedBharatSatExamNameFilter === "" // Special case for "All"
                        ? { value: "", label: "Bharat SAT Exam Name" }
                        : { value: selectedBharatSatExamNameFilter, label: selectedBharatSatExamNameFilter } // For other options
                    }
                  />
                </div>
              </div>
            </div>
          </div>

          <div className=" row table_title align-items-center responsivetablepackagetwo">

            <div className="col-xl-10 my-2 col-lg-12 col-md-12 gap-2 Responsivesearchbars  align-items-center d-flex">
              <CustomDropDown
                // labelTitle="Filter By Class"
                placeholder="Class"
                name="class"
                id="class"
                Dropdownclass={"col-md-8 col-lg-3 col-sm-12 marginsection"}
                labelClass="commissionsection"
                onChange={handleClassChange}
                options={
                  [{ value: "", label: "All" }, ...classes.map((e) => { return { value: e._id, label: e.class_name } }) ?? []]
                }
                value={selectedClassFilter}
              />
              <CustomDropDown
                placeholder="Medium"
                name="medium"
                id="medium"
                Dropdownclass={"col-md-8 col-lg-3 col-sm-12 marginsection"}
                options={
                  [{ value: "", label: "All" }, ...mediumList ?? []]
                }
                value={selectedmedium}
                labelClass="commissionsection"
                onChange={handleMediumChange}

              />
              <div className=" col-md-8 col-lg-3 col-sm-12 ">
                <CustomDropDown
                  placeholder="Select District"
                  inputType={InputType.text}
                  Dropdownclass="marginsection"
                  labelClass="commissionsection"
                  resetValue={resetFilterDistrict}
                  setResetValue={setResetFilterDistrict}
                  onChange={handleDistrictChange}
                  options={[
                    { value: "", label: "All" },
                    ...filterDistricts?.map((e) => ({
                      value: e._id,
                      label: e.name,
                    })) ?? [],
                  ]}
                  value={
                    selectedDistrictFilter.id === "" || selectedDistrictFilter.name === "" // Special case for "All"
                      ? { value: "", label: "All" } // If "All" is selected, set it explicitly
                      : selectedDistrictFilter.id || selectedDistrictFilter.name // For other options
                        ? { value: selectedDistrictFilter.id, label: selectedDistrictFilter.name }
                        : undefined // Show placeholder if nothing is selected
                  }
                />
              </div>

              <div className="col-md-8 col-lg-3  col-sm-12">
                <CustomDropDown
                  placeholder="Select Taluka"
                  inputType={InputType.text}
                  resetValue={resetFilterTaluka}
                  Dropdownclass="marginsection"
                  labelClass="commissionsection"
                  setResetValue={setResetFilterTaluka}
                  onChange={(e) => {
                    setSelectedTalukaFilter({ name: e.value })
                    setOffset(0);
                  }}
                  options={[
                    { value: "", label: "All" },
                    ...filterTalukas?.map((e) => {
                      return { value: e.name, label: e.name }
                    }) ?? []]}
                  value={
                    selectedTalukaFilter.name === "" // Special case for "All"
                      ? { value: "", label: "All" }
                      : selectedTalukaFilter.name // For other options
                        ? { value: selectedTalukaFilter.name, label: selectedTalukaFilter.name }
                        : undefined // Show placeholder if nothing is selected
                  }
                />
              </div>
            </div>

            <div className="col-md-12  col-lg-12 col-xl-2  col-12 d-flex align-items-center justify-content-end respoexportbtn ">
              <ButtonWithIcon
                text={"Export"}
                icon={PngImages.xlspic}
                onClick={handleExportClick}
              />
            </div>
          </div>

          <div style={{ overflowX: "auto" }}>
            <table
              className="table mb-0 "
              id="dtHorizontalExample"
              cellSpacing="0"
              width="100%"
            >
              <thead>
                <tr className="table_heading">
                  <th scope="col" style={{ width: "5%" }}>
                    <label className="d-flex align-items-center justify-content-center">
                      <input
                        className="cursor-pointer"
                        type="checkbox"
                        style={{ height: "16px", aspectRatio: 1 }}
                        checked={
                          data?.length > 0 &&
                          data?.findIndex((item) => !item.isChecked) == -1
                        }
                        onChange={(value) => {
                          var updatedData = data;
                          updatedData.map((element) => {
                            element.isChecked = value.target.checked;
                          });
                          setData([...updatedData]);
                        }}
                      />
                      <span className="checkmark"></span>
                    </label>
                  </th>
                  <th scope="col" style={{ width: "5%" }}>
                    Sr No.
                  </th>
                  <th scope="col" style={{ width: "10%" }}>
                    Hall Ticket
                  </th>
                  <th scope="col" style={{ width: "15%" }}>
                    Name
                  </th>
                  <th scope="col" style={{ width: "15%" }}>
                    BharatSat Exam Name
                  </th>
                  <th scope="col" style={{ width: "10%" }}>
                    Class
                  </th>
                  <th scope="col" style={{ width: "10%" }}>
                    Medium
                  </th>
                  <th scope="col" style={{ width: "10%" }}>
                    District
                  </th>
                  <th scope="col" style={{ width: "10%" }}>
                    Taluka
                  </th>
                  <th scope="col" style={{ width: "5%" }}>
                    Marks
                  </th>
                  <th scope="col" style={{ width: "5%" }}>
                    Action
                  </th>
                </tr>
              </thead>
              <tbody className="bg_light">
                {data?.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <label className="d-flex align-items-center justify-content-center">
                        <input
                          className="cursor-pointer"
                          type="checkbox"
                          checked={item.isChecked || false}
                          style={{ height: "16px", aspectRatio: 1 }}
                          onChange={(value) => {
                            var updatedData = data;
                            updatedData[index].isChecked = value.target.checked;
                            setData([...updatedData]);
                          }}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </td>
                    <td>{limit * offset + (index + 1)}</td>
                    <td >
                      {item.hallTicketNumber}
                    </td>
                    <td className="text-capitalize">
                      {item.firstName + " " + item.lastName}
                    </td>
                    <td>{item.bharatSatExamName}</td>
                    <td>{item.class_name}</td>
                    <td>{item.medium}</td>
                    <td>{item.district}</td>
                    <td>{item.taluka}</td>
                    <td>{Math.max(item.score, 0) + "/" + item.totalNumberOfMarks}</td>
                    <td>
                      <a
                        className="cursor-pointer"
                        style={{ textDecoration: "underline" }}
                        onClick={() => {
                          setDataTwo(item);
                          fetchResult(item.bharatSatSubmissions_id, item.subject_id)
                          setShowDropdown(false);
                          setButtonIcon(false ? SvgImages.tick_mark : SvgImages.magicalstar);
                        }}
                      >
                        View
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {generatePaginationFooter(availableDataCount, limit, offset, setOffset)}
        </div>
      )}
      <ConfirmationModal
        showModal={showDeleteModal}
        setShowModal={setShowDeleteModal}
        text={
          isMultipleDelete
            ? "Are you sure want to delete selected Users?"
            : "Are you sure want to delete User?"
        }
        icon={SvgImages.deleteIcon} // Specify the path to your delete icon
        rightClickAction={() => {
          isMultipleDelete ? deleteMultipleuser() : deleteSingleUser(deleteId);
        }}
        theme={ConfirmationModalTheme.error}
      />
    </div>
  );
};

export default BharatSatExamResult;
